import type { MutationOptions } from '@tanstack/react-query';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import {
  handleResponseSuccess,
  handleResponseThrowError,
} from '@/_utils/services';
import { GET_BLOCKS_DELIVERYMAN } from './constants';
import type { BlockType } from '../motoboy-details/components/form-to-block/types';
import { apiClient } from '@/_config/lib/axios/api-client';

type PostBlockDeliverymanParams = {
  deliverymanId: string;
  placeId?: string | null;
  blockReason: string;
  period?: number;
  periodType?: string;
  hasBlockedAll: boolean;
  blockType: BlockType;
};

const postBlockDeliveryman = (params: PostBlockDeliverymanParams) => {
  const {
    deliverymanId,
    placeId,
    blockReason,
    period,
    periodType,
    hasBlockedAll,
    blockType,
  } = params;

  return apiClient
    .post<boolean>(`/entregadores/v2/${deliverymanId}/block`, {
      placeId,
      blockReason,
      period,
      periodType,
      hasBlockedAll,
      blockType,
    })
    .then(response =>
      handleResponseSuccess(
        response.data,
        'As informações foram enviadas com sucesso!',
      )(),
    )
    .catch(handleResponseThrowError());
};

const usePostBlockDeliveryman = ({
  onSuccess,
  ...options
}: MutationOptions<boolean, unknown, PostBlockDeliverymanParams> = {}) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: postBlockDeliveryman,
    onSuccess: (...args) => {
      queryClient.invalidateQueries([GET_BLOCKS_DELIVERYMAN], { exact: false });
      onSuccess?.(...args);
    },
    ...options,
  });
};

export { usePostBlockDeliveryman };
